import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import { View } from '@dbk/ui-react-utils';
import Text from '@dbk/ui-text';
import PlusSign from '../../icons/plus-sign';
import MinusSign from '../../icons/minus-sign';
import { testIDProps } from '../../utils/with-automation-id-props';
import { CHANNEL_TYPES, PALETTE } from '../../../../constants';
import styles from './legend.styles';

const LegendHeader = ({ showLegend, messages = {}, toggleLegend, style = {} , channel = {}}) => {
  return (
    <View style={{ width: '100%', marginBottom: 26 }} onClick={toggleLegend}>
      {!showLegend &&
        <View style={{ flexDirection: 'row', justifyContent: 'center', display: 'flex' }}>
          <Text style={{ color: '#a7a8aa' }}
            {...testIDProps("txt_show_legend_portfolio_test")}>
            {messages['app.portfolio.circularChart.viewLegend']}
          </Text>
          <View style={{ marginRight: 5, marginTop: 5, marginLeft: 3, marginBottom: 2, }}
            {...testIDProps("btn_view_plus_sign_portfolio_test")}>
            <PlusSign fill="#a3a4a7" scale={0.60} />
          </View>
        </View>}
      {showLegend &&
        <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
          <View style={{ flexGrow: 1, height: 2, marginRight: 15, backgroundColor: '#252F44' }} />
          <Text style={{ color:PALETTE.primaryActive }}
            {...testIDProps("txt_hide_legend_portfolio_test")}>
            {messages['app.portfolio.circularChart.hideLegend']}
          </Text>
          <View style={{ marginLeft: 5, marginRight: 15, marginTop: 0, marginBottom: 2 }}
            {...testIDProps("btn_view_minus_sign_portfolio_test")}>
            <MinusSign width={10} height={10} fill={PALETTE.primaryActive}/>
          </View>
          <View style={{ flexGrow: 1, height: 2, backgroundColor: '#252F44' }} />
        </View>}
    </View>
  )
};

LegendHeader.propTypes = {
  messages: PropTypes.object.isRequired,
  showLegend: PropTypes.bool.isRequired,
  toggleLegend: PropTypes.func.isRequired,
};

LegendHeader.defaultProps = {
  showLegend: false,
  toggleLegend: noop,
};

export default LegendHeader;
